module.exports = __webpack_public_path__ + "files/e2a4efdc9d43bbfbdb952e03da9ca279.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-3.png
// module id = 1478
// module chunks = 60